// extracted by mini-css-extract-plugin
export var button = "styles-module--button--a693a";
export var content = "styles-module--content--27940";
export var description = "styles-module--description--889de";
export var descriptionContainer = "styles-module--descriptionContainer--ce2e5";
export var exam = "styles-module--exam--09279";
export var layout = "styles-module--layout--041da";
export var secondary = "styles-module--secondary--4d1ca";
export var title = "styles-module--title--22325";